"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _svg = require("../../../../../configuration/svg");

var _utils = require("../../../../../configuration/utils");

var _convertEntities = _interopRequireDefault(require("../../../../../configuration/convertEntities"));

var _PEPAccordionCompatibilityGuide = _interopRequireDefault(require("../../../../PEP-accordion/js/PEP-accordion-compatibility-guide"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// import Overlay from '../../../../PEP-modal/js/overlay';
// import HelpText from '../../../../PEP-modal/js/help-text';
var CompatibilityComponent = function CompatibilityComponent(_ref) {
  var currentTab = _ref.currentTab,
      tabName = _ref.tabName,
      devices = _ref.devices;
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  var selectedProduct = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct;
  });
  var isMobile = (0, _reactRedux.useSelector)(function (state) {
    return state.isMobile;
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var handleHelpClick = function handleHelpClick(evt) {
    evt.preventDefault();
    setShowModal(true);
  };

  var handleHelpClose = function handleHelpClose() {
    setShowModal(false);
  };

  var renderMobileOsVersion = "<ul>\n      <li>".concat(dictionary.android, " ").concat(selectedProduct.androidVersion, " ").concat(dictionary.laterLabel, "</li>\n      <li>").concat(dictionary.ios, " ").concat(selectedProduct.iosVersion, " ").concat(dictionary.laterLabel, "</li>\n    </ul>");

  var renderSupportedDevices = function renderSupportedDevices() {
    var sortedDevices = devices.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
    var input = ['Samsung', 'Google', 'Sony', 'Motorola', 'Moto', 'HTC', 'LG', 'Xiaomi', 'Huawei', 'ZTE', 'OnePlus', 'iPhone'];
    var inputSorted = input.sort(function (a, b) {
      return a.localeCompare(b);
    });
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginBottom: 25,
        color: 'white'
      }
    }, inputSorted.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_PEPAccordionCompatibilityGuide["default"], {
        element: item,
        elementsObj: sortedDevices,
        currIndex: index,
        activeOnLoad: -1,
        key: index,
        contentFontRegular: true
      });
    })));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: currentTab === tabName ? "tab__content__section active compatibility" : "tab__content__section compatibility",
    "data-content": tabName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab__content__section__row"
  }, isMobile ? '' : /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab__content__section__row__image"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "compatibilitySVG",
    dangerouslySetInnerHTML: {
      __html: _svg.compatibilitySVG
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab__content__section__row__description"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: 5
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "tab__content__section__title"
  }, dictionary.phoneCompatibility), /*#__PURE__*/_react["default"].createElement("p", {
    className: "tab__content__section__description__sub"
  }, (0, _convertEntities["default"])(selectedProduct.title), " ", (0, _convertEntities["default"])(selectedProduct.subtitle), " ", (0, _convertEntities["default"])(dictionary.compatibilityDescription)), /*#__PURE__*/_react["default"].createElement("p", {
    className: "tab__content__section__description__desc ios"
  }, dictionary.appleDevices, ": ", dictionary.ios, " ", selectedProduct.iosVersion, " ", dictionary.laterLabel), /*#__PURE__*/_react["default"].createElement("p", {
    className: "tab__content__section__description__desc android"
  }, dictionary.androidDevices, ": ", dictionary.android, " ", selectedProduct.androidVersion, " ", dictionary.laterLabel), /*#__PURE__*/_react["default"].createElement("p", {
    className: "tab__content__section__description__desc moreInformation"
  }, dictionary.moreInformation, " ", /*#__PURE__*/_react["default"].createElement("a", {
    href: dictionary.compatibilityGuideLink,
    onClick: function onClick(e) {
      return (0, _utils.sendDataLayerEvent)('Tab', "Compatibility > ".concat(dictionary.compatibilityGuideLink));
    },
    tabIndex: 5
  }, dictionary.compatibilityGuide))))));
};

var _default = CompatibilityComponent;
exports["default"] = _default;